import React from "react";
import { Box, Grid, Typography, Paper, Divider, List, ListItem, ListItemText } from "@mui/material";

const Resume30 = ({ 
  color = "#6c5ce7", 
  font = "Roboto", 
  fontSize = "14px", 
  headingSize = "24px" 
}) => {
  return (
    <Box sx={{ 
      width: "210mm", 
      minHeight: "297mm", 
      mx: "auto", 
      bgcolor: "#fff", 
      fontFamily: font,
      boxShadow: "0 0 10px rgba(0,0,0,0.1)",
      "@media print": { boxShadow: "none" }
    }}>
      {/* Top Banner - Header Section */}
      <Box sx={{ bgcolor: color, color: "white", p: 5, textAlign: "left" }}>
        <Typography sx={{ fontSize: "40px", fontWeight: "900", lineHeight: 1 }}>
          RICHARD SANCHEZ
        </Typography>
        <Typography sx={{ fontSize: "18px", mt: 1, letterSpacing: 2, opacity: 0.9 }}>
          SENIOR MARKETING MANAGER
        </Typography>
      </Box>

      <Grid container>
        {/* Left Column (Skills, Education, Contact) */}
        <Grid item xs={4} sx={{ bgcolor: "#f8f9fa", p: 4, minHeight: "240mm" }}>
          
          <Typography sx={{ fontWeight: "bold", mb: 2, color: color }}>CONTACT</Typography>
          <Box sx={{ mb: 4, fontSize: "13px" }}>
            <Typography sx={{ mb: 1 }}>📞 +123-456-7890</Typography>
            <Typography sx={{ mb: 1 }}>✉️ hello@reallygreatsite.com</Typography>
            <Typography sx={{ mb: 1 }}>📍 123 Anywhere St., Any City</Typography>
            <Typography sx={{ mb: 1 }}>🌐 www.reallygreatsite.com</Typography>
          </Box>

          <Typography sx={{ fontWeight: "bold", mb: 2, color: color }}>CORE SKILLS</Typography>
          <Box sx={{ mb: 4 }}>
            {[
              "Project Management",
              "Public Relations",
              "Market Research",
              "SEO & SEM",
              "Team Leadership",
              "Budget Planning"
            ].map(skill => (
              <Typography key={skill} sx={{ fontSize: "13px", mb: 1, display: 'flex', alignItems: 'center' }}>
                <Box component="span" sx={{ width: 6, height: 6, bgcolor: color, borderRadius: '50%', mr: 1 }} />
                {skill}
              </Typography>
            ))}
          </Box>

          <Typography sx={{ fontWeight: "bold", mb: 2, color: color }}>EDUCATION</Typography>
          <Box sx={{ mb: 4 }}>
            <Typography sx={{ fontWeight: "bold", fontSize: "13px" }}>Master of Business</Typography>
            <Typography sx={{ fontSize: "12px" }}>Wardiere University</Typography>
            <Typography sx={{ fontSize: "12px", mb: 2, color: "gray" }}>2029 - 2030</Typography>

            <Typography sx={{ fontWeight: "bold", fontSize: "13px" }}>Bachelor of Business</Typography>
            <Typography sx={{ fontSize: "12px" }}>Wardiere University</Typography>
            <Typography sx={{ fontSize: "12px", color: "gray" }}>2025 - 2029</Typography>
          </Box>

          <Typography sx={{ fontWeight: "bold", mb: 2, color: color }}>AWARDS</Typography>
          <Typography sx={{ fontSize: "12px" }}>• Employee of the Year (2028)</Typography>
          <Typography sx={{ fontSize: "12px" }}>• Best Campaign Strategy (2026)</Typography>
        </Grid>

        {/* Right Column (Profile, Experience, References) */}
        <Grid item xs={8} sx={{ p: 4, bgcolor: "white" ,width:{xs:"500px"}}}>
          
          <Typography variant="h6" sx={{ color: color, fontWeight: "bold", mb: 1 }}>PROFILE</Typography>
          <Typography sx={{ fontSize: fontSize, mb: 4, textAlign: 'justify', lineHeight: 1.6 }}>
            Highly creative and results-driven Marketing Manager with over 8 years of experience in 
            developing and executing successful marketing strategies. Expert in digital advertising, 
            brand management, and leading cross-functional teams to exceed business goals.
          </Typography>

          <Typography variant="h6" sx={{ color: color, fontWeight: "bold", mb: 2 }}>WORK EXPERIENCE</Typography>
          
          {[
            {
              company: "Borcelle Studio",
              pos: "Senior Marketing Manager",
              year: "2030 - Present",
              desc: [
                "Developed and executed annual marketing plans and budgets.",
                "Led a team of 10+ specialists to increase brand awareness by 40%.",
                "Managed high-scale digital campaigns across social media platforms."
              ]
            },
            {
              company: "Fauget Studio",
              pos: "Marketing Specialist",
              year: "2025 - 2029",
              desc: [
                "Oversaw market research projects to identify new consumer trends.",
                "Increased lead generation by 25% through SEO optimization.",
                "Collaborated with the creative team for product launches."
              ]
            }
          ].map((job, index) => (
            <Paper key={index} elevation={0} sx={{ 
              p: 2, 
              borderLeft: `4px solid ${color}`, 
              mb: 3, 
              bgcolor: "#f9f9f9" 
            }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                <Typography sx={{ fontWeight: "bold" }}>{job.company}</Typography>
                <Typography sx={{ fontSize: "12px", color: "gray" }}>{job.year}</Typography>
              </Box>
              <Typography sx={{ fontWeight: 500, mb: 1, color: "#444" }}>{job.pos}</Typography>
              <ul style={{ margin: 0, paddingLeft: '20px', fontSize: '13px' }}>
                {job.desc.map((item, i) => (
                  <li key={i} style={{ marginBottom: '4px' }}>{item}</li>
                ))}
              </ul>
            </Paper>
          ))}

          <Typography variant="h6" sx={{ color: color, fontWeight: "bold", mt: 4, mb: 2 }}>REFERENCES</Typography>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Typography sx={{ fontWeight: "bold", fontSize: "14px" }}>Estelle Darcy</Typography>
              <Typography sx={{ fontSize: "12px" }}>Wardiere Inc. / CTO</Typography>
              <Typography sx={{ fontSize: "12px" }}>P: +123-456-7890</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography sx={{ fontWeight: "bold", fontSize: "14px" }}>Harper Richard</Typography>
              <Typography sx={{ fontSize: "12px" }}>Wardiere Inc. / CEO</Typography>
              <Typography sx={{ fontSize: "12px" }}>P: +123-456-7890</Typography>
            </Grid>
          </Grid>

        </Grid>
      </Grid>
    </Box>
  );
};

export default Resume30;
export const resumeMeta = {
  hasPhoto: false,
  columns: 2,
  colorOptions: [
    { value: '#2196f3', label: 'Blue' },
    { value: '#4caf50', label: 'Green' },
    { value: '#ff9800', label: 'Orange' },
    { value: '#9c27b0', label: 'Purple' },
    { value: '#f44336', label: 'Red' }
  ]
};